import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Manifesto from "@/components/site/Manifesto";
import MeetRomii from "@/components/site/MeetRomii";
import WhyWeBuilt from "@/components/site/WhyWeBuilt";
import DayWithRomii from "@/components/site/DayWithRomii";
import WhyRomii from "@/components/site/WhyRomii";
import Assistance from "@/components/site/Assistance";
import Audiences from "@/components/site/Audiences";
import Stage from "@/components/site/Stage";
import Vision from "@/components/site/Vision";
import FAQ from "@/components/site/FAQ";
import ContactSection from "@/components/site/ContactSection";
import Newsletter from "@/components/site/Newsletter";
import Footer from "@/components/site/Footer";
import Admin from "@/pages/Admin";

const Home = () => (
  <div className="bg-white">
    <Navbar />
    <main>
      <Hero />
      <Manifesto />
      <MeetRomii />
      <WhyWeBuilt />
      <DayWithRomii />
      <WhyRomii />
      <Assistance />
      <Audiences />
      <Stage />
      <Vision />
      <FAQ />
      <ContactSection />
      <Newsletter />
    </main>
    <Footer />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      autoRaf: true,
      anchors: { offset: -96 },
      lerp: 0.09,
    });
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
